import { ProviderMedicalRole } from '@uplift/types';
import { restClient } from '../client';
import { Appointment, AppointmentRecurring } from '../resources';


export type NextSessionsInput = {
  limit: number;
  dt_from?: string;
  patient_id?: string;
  appointments_per_series?: number;
  provider_id?: string;
};


export type NextSingleSession = Appointment & {
  recurring: null | AppointmentRecurring.none;
  appointmentSeriesId: null;
  provider: {
    id: string;
    firstName: string;
    lastName: string;
    medicalRole: ProviderMedicalRole;
    preferredName: string;
  };
};


export type NextRecurringSession = Appointment & {
  recurring: AppointmentRecurring;
  appointmentSeriesId: string;
  provider: {
    id: string;
    firstName: string;
    lastName: string;
    medicalRole: ProviderMedicalRole;
    preferredName: string;
  };
};


export type NextSession = NextSingleSession | NextRecurringSession;


export type NextSessionsOutput = {
  data: NextSession[];
};


export const nextSessions = restClient.createRequest<NextSessionsInput, NextSessionsOutput>({
  url: '/api/v1/appointments/next-patient-sessions',
  method: 'GET',
});

export const patientCareTeamNextAppointments = (patientId: string) =>
  restClient.request<{ data: Appointment[] }>(
    `/api/v1/patient/${patientId}/care-team/next-appointments`,
    {
      method: 'GET'
    }
  );

export type FollowUpSessionOutput = {
  data: NextSession;
};

export const followUpSession = (appointmentId: string) => restClient.request<FollowUpSessionOutput>(`/api/v1/appointment/${appointmentId}/follow-up-patient-session`, { method: 'GET' });
